<template>
  <div>
    <b-modal
      ref="sign-in"
      v-model="showModal"
      size="md"
      centered
      body-class="d-flex align-items-center"
      title-tag="span"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
    >
      <template v-slot:modal-title>
        Session Timeout
      </template>
      <p>You have {{this.timer}} seconds until session timeout.</p>
      <template v-slot:modal-footer class="d-flex">
          <b-button pill variant="primary" @click="staySignedIn" aria-label="Stay signed in">Stay signed in</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';

export default {
  name: 'TimeoutModal',
  data() {
    return {
      showModal: false,
      timerInterval: null,
    };
  },
  computed: {
    timer() {
      return 60 - this.timeoutCountdown;
    },
    ...mapState('User', {
      timeoutPending: state => state.timeoutPending,
      timeoutCountdown: state => state.timeoutCountdown,
    }),
  },
  watch: {
    timeoutPending(newValue) {
      if (newValue) this.openModal();
      else this.closeModal();
    },
    timer(value) {
      if (value <= 0) {
        this.$store.dispatch('User/inactivityTimeout');
      }
    },
  },
  methods: {
    openModal() {
      this.setTimer();
      this.$emit('modalOpened');
      this.showModal = true;
    },
    closeModal() {
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.showModal = false;
    },
    setTimer() {
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        this.$store.dispatch('User/incrementCountdown');
      }, 1000);
    },
    staySignedIn() {
      api.post('/extendSignIn').then(() => {
        this.$store.dispatch('User/resetTimeout');
      });
    },
  },
};
</script>
